import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a69af50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-content" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-gap" }, null, -1))
const _hoisted_4 = { class: "artist-name" }
const _hoisted_5 = {
  key: 0,
  class: "sep"
}
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "card-body-content" }
const _hoisted_8 = { class: "card-body-text" }
const _hoisted_9 = { class: "artist-info" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Full Name", -1))
const _hoisted_11 = { class: "artist-info" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Alias Name", -1))
const _hoisted_13 = { class: "artist-info" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Category", -1))
const _hoisted_15 = { class: "artist-tag" }
const _hoisted_16 = { class: "artist-info" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "City", -1))
const _hoisted_18 = { class: "artist-tag" }
const _hoisted_19 = { class: "artist-info" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Description", -1))
const _hoisted_21 = { class: "artist-info" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Address", -1))
const _hoisted_23 = { class: "artist-info" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Phone Number", -1))
const _hoisted_25 = { class: "artist-info" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Website", -1))
const _hoisted_27 = {
  key: 0,
  class: "artist-info"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Portfolio URL for Registration", -1))

import '@/assets/sass/profil.sass'
import store from "@/store";
import {useRouter} from "vue-router";
import { ArtistModel, CategoryModel } from "@/types/ArtistModel";
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Profile',
  props: {
    artist: null,
    editable: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  artist?: ArtistModel,
  editable?: boolean
}

const router = useRouter()



function editPage() {
  router.push('/profil/edit')
}

const categories_displayed = computed( () => {
  if (props.artist ) {
    return props.artist.categories.join(", ")
  }
  return ""
})


const bgImgPlaceholder = computed( () => {
  if (props.artist) {
    return {
      backgroundImage: `url(${ props.artist.photo_url  || require('@/assets/img/photo-placeholder.png')})`
    }
  }
  return { backgroundImage: `url(${require('@/assets/img/photo-placeholder.png')})` }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: "photo",
        style: _normalizeStyle(_unref(bgImgPlaceholder))
      }, null, 4),
      _createElementVNode("p", _hoisted_4, _toDisplayString(__props.artist!.user.full_name), 1),
      _createElementVNode("div", {
        class: _normalizeClass(["status", { green: __props.artist.status }]),
        ref: "status"
      }, _toDisplayString(__props.artist.status ? 'ACTIVE' : 'INACTIVE'), 3)
    ]),
    (!_unref(store).state.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("p", null, _toDisplayString(__props.artist.user.full_name), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("p", null, _toDisplayString(__props.artist.user.username), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.artist.categories, (category) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "profile-tag",
                  key: category
                }, _toDisplayString(category), 1))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.artist.cities, (city) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "profile-tag",
                  key: city
                }, _toDisplayString(city), 1))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("p", null, _toDisplayString(__props.artist.user.description), 1)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("p", null, _toDisplayString(__props.artist.address), 1)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("p", null, _toDisplayString(__props.artist.phone_number), 1)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("p", null, _toDisplayString(__props.artist.website), 1)
          ]),
          (!__props.artist.status)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("p", null, _toDisplayString(__props.artist.portfolio_url_reg), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createElementVNode("button", {
          onClick: editPage,
          class: "brand"
        }, "Edit Profile", 512), [
          [_vShow, __props.editable]
        ])
      ])
    ])
  ]))
}
}

})